import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextLink"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicNextLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/vercel/path0/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["ExpandableDiv"] */ "/vercel/path0/src/components/global/ExpandableDiv/ExpandableDiv.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/global/LinkAsButton/LinkAsButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CarouselReviews"] */ "/vercel/path0/src/components/sections/CarouselReviews/CarouselReviews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedProducts"] */ "/vercel/path0/src/components/sections/FeaturedProducts/FeaturedProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabContent"] */ "/vercel/path0/src/components/sections/TabContent/TabContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ValueChain"] */ "/vercel/path0/src/components/sections/ValueChain/ValueChain.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/VideoCards.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/VideoSection.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/TextWithHeading.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/TwoThirdsImageText.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/global/FlexibleImage.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/ThreeImageSection.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/TextImageCard.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/TextColumns.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/StandardSection2.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/SocialLinks.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/SingleReview.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/global/StarRating.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/StandardSection1.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/Hero/Hero.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/IconCards.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/ContentCards.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/Buttons.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/CardsSection1.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/Article.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/sections/Accordion.module.css");
